import { BigNumber } from 'bignumber.js';
import FooterControl from '@/components/FooterControl.vue';
import { cloneDeep } from 'lodash';
import payDialog from '../pay/index.vue';
import { GENDER_OPTOINS } from '@/config/constant';
import { REG_AMT } from '@/utils/validate/regExp';

import medicinePrint from '@/components/medicinePrint/index.vue';
import receiptPrint from '@/components/receiptPrint/index.vue'; // 小票打印
import piecesPrint from '@/components/piecesPrint/index.vue'; // 饮片打印
import infusionPrint from '@/components/infusionPrint/index.vue'; // 输液打印
import applyPrint from '@/components/applyPrint/index.vue'; // 敷贴打印
import otherPrint from '@/components/otherPrint/index.vue'; // 其他打印
import infusionCardPrint from '@/components/infusionCardPrint/index.vue';  // 输液打印卡
import noPrintTips from '@/components/noPrintTips.vue';
import { getLodop } from '@/plugins/LodopFuncs';

const BN = BigNumber.clone();
BN.config({ DECIMAL_PLACES: 2 });
const isChecked = item => item.checked;

export default {
  name: 'waitfee-detail',
  components: {
    FooterControl,
    payDialog,
    medicinePrint,
    receiptPrint,
    piecesPrint,
    infusionPrint,
    infusionCardPrint,
    applyPrint,
    otherPrint,
    noPrintTips,
  },
  data() {
    return {
      recordVersion: '', // 后端校验订单版本
      newRecordVersion: '', // 新订单版本
      hasCoupon: false,
      couponId: '',
      couponType: 0,
      couponVal: {},
      tableData: [],
      value: '',
      orderInfo: {}, // 订单信息
      inquiryInfo: {}, // 诊断信息
      patient: {}, // 患者信息
      orderAdditionList: [], // 附加费用
      orderExamList: [], // 检查治疗项
      orderPrescriptionList: [], // 处方
      wPrescription: [], // 西药处方
      ePrescription: [], // 中药处方
      infusionPrescription: [], // 输液卡处方
      applyPrescription: [], // 贴敷
      wipeZero: 0.00, // 抹零
      dialogVisible: false,
      serverTotal: '0.00', // 后台价格
      scriptList: {}, // 传给小票打印的数据
      record: {
        patient: {
          patientName: '',
        },
        inquiryInfo: {
          diagnosisResultString: '',
        },
        medicineDrugPrescriptionList: [
          {
            patientDrugList: [],
          },
        ],
      }, // 病历详情
      review: false, // 开启打印预览模式
      printShow: false,
      debtorInfo: {
        name: '',
        phone: '',
      }, // 欠费人信息
      sellDrugWithoutInventory: 1, // 是否开启无库存售药 1：是 0：否
    };
  },

  methods: {
    goback() {
      this.$router.push({ name: 'waitFee' });
    },
    getTableData() {
    },
    getDetail() {
      const { id } = this.$route.query;
      this.$api.feeDispense.pendingOrderDetail({ id }).then((res) => {
        this.recordVersion = res.recordVersion;
        this.orderInfo = res;
        this.inquiryInfo = res.inquiryInfo;
        this.patient = res.patient;
        const initScript = (item) => {
          const script = cloneDeep(item);
          script.discountAmt = '0.00';
          script.checked = true;
          script.items = script.items.map((it) => {
            if (it.batches) {
              if (it.batches.length === 0) {
                it.drugBatchNo = '--';
              }
              it.drugBatchNo = it.batches[0];
            }
            return it;
          });
          return script;
        };
        // 匹配性别
        if (GENDER_OPTOINS.find(it => this.patient.gender === it.value)) {
          this.patient.gender = GENDER_OPTOINS.find(it => this.patient.gender === it.value).label;
        } else {
          this.patient.gender = '';
        }
        this.orderAdditionList = res.orderAdditionList.map(initScript);
        this.orderExamList = res.orderExamList.map(initScript);
        this.orderPrescriptionList = res.orderPrescriptionList.map(initScript);
        const orderList = res.orderPrescriptionList;
        console.log(orderList);
        this.wPrescription = orderList.filter(item => item.type === 1).map(initScript);
        this.ePrescription = orderList.filter(item => item.type === 2).map(initScript);
        this.infusionPrescription = orderList.filter(item => item.type === 6).map(initScript);
        this.applyPrescription = orderList.filter(item => item.type === 7).map(initScript);
        this.getRecord();
      });
    },
    getRecord() {
      this.$api.outPatient.getRecord({ recordId: this.inquiryInfo.recordId }).then((res) => {
        this.record = res;
      });
    },
    totalPrice(count, price) {
      return BN(price).multipliedBy(count).toFixed(3);
    },
    totalPriceSticker(count, gramCount, price) {
      return BN(price).multipliedBy(count).multipliedBy(gramCount).toFixed(3);
    },
    // 修改批号
    modifyDrug(drugBatchNo, it, item, objName, index, idx) {
      this.$api.feeDispense.modifyDrug({
        drugBatchNo,
        drugId: it.drugId,
        orderItemId: item.id,
      }).then(() => {
        // 新需求:后端处理前端不显示药品 在售药的时候后端自己做扣除
        // const drugIndex = durgList.findIndex(drug => drug.drugId === it.drugId);
        // durgList = durgList.filter(drug => drug.drugId !== it.drugId);
        // durgList.splice(drugIndex, 0, ...res);
        // this[objName][index].items = durgList;
      }).catch(() => {});
    },
    // 单个处方获取优惠
    scriptMinusOffer(total, offer) {
      const price = Number(offer);
      const totalPrice = Number(total);
      // if (totalPrice < price) {
      //   this[scriptName][index].discountAmt = totalPrice;
      // }
      if (isNaN(price) || price === 0 || totalPrice < price) {
        return BN(total).toFixed(2);
      }
      return BN(total).minus(offer).toFixed(2);
    },
    confirm() {
      let wList = this.wPrescription.filter(isChecked);
      let eList = this.ePrescription.filter(isChecked);
      let inList = this.infusionPrescription.filter(isChecked);
      let appList = this.applyPrescription.filter(isChecked);
      let examList = this.orderExamList.filter(isChecked);
      let addList = this.orderAdditionList.filter(isChecked);
      
      const changeDiscountAmt = (item) => {
        if (item.discountAmt === '') item.discountAmt = 0;
        return item;
      };
      wList = wList.map(changeDiscountAmt);
      eList = eList.map(changeDiscountAmt);
      inList = inList.map(changeDiscountAmt);
      appList = appList.map(changeDiscountAmt);
      examList = examList.map(changeDiscountAmt);
      addList = addList.map(changeDiscountAmt);
      // 优惠金额验证
      const validateDiscount = item => (item.receivableAmt < item.discountAmt || !REG_AMT.test(item.discountAmt));
      const wValidateDiscount = wList.some(validateDiscount);
      const eValidateDiscount = eList.some(validateDiscount);
      const inValidateDiscount = inList.some(validateDiscount);
      const appValidateDiscount = appList.some(validateDiscount);
      const examValidateDiscount = examList.some(validateDiscount);
      const addValidateDiscount = addList.some(validateDiscount);

      if (wValidateDiscount) {
        this.$message({
          message: '成药处方部分优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (eValidateDiscount) {
        this.$message({
          message: '饮片处方部分优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (inValidateDiscount) {
        this.$message({
          message: '输液卡处方部分优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (appValidateDiscount) {
        this.$message({
          message: '贴敷处方部分优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (examValidateDiscount) {
        this.$message({
          message: '检查治疗项部分优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      if (addValidateDiscount) {
        this.$message({
          message: '附加费用部分优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      // 没有输入的情况下默认给 0
      if (this.wipeZero === '') this.wipeZero = 0;
      if (Number(this.allTotalPrice) < Number(this.allOffer) || !REG_AMT.test(this.wipeZero)) {
        this.$message({
          message: '抹零优惠优惠输入不正确！',
          type: 'warning',
        });
        return;
      }
      let orderItems = [
        ...addList,
        ...examList,
        ...wList,
        ...eList,
        ...inList,
        ...appList,
      ];
      orderItems = orderItems.map(item => ({ id: item.id, discountAmt: item.discountAmt }));
      const req = {
        orderItems,
        wipeAmt: this.wipeZero,
        actualReceivableAmt: this.receivable,
        receivableAmt: this.allTotalPrice,
        discountAmt: this.offer,
        couponDiscountAmt: this.couponAmt,
        couponCode: this.couponId,
        id: this.$route.query.id,
        recordVersion: this.recordVersion,
      };
      // 小票打印的数据
      // this.scriptList = {
      //   medicineDrugPrescriptionList: wList,
      //   patientChineseDrugList: eList,
      //   patientInfusionList: inList,
      //   patientStickingDrugGroupList: appList,
      //   orderExam: examList,
      //   orderAddition: addList,
      //   receivableAmt: this.allTotalPrice,
      //   totalDiscountAmt: this.offer,
      //   actualReceivableAmt: this.receivable,
      // };
      // 打印拦截如果没有安装打印机插件
      const LODOP = getLodop();
      if (!LODOP && this.isPrint) {
        this.printShow = true;
        return;
      }
      // 传入默认的欠费人信息
      this.debtorInfo.name = this.patient.patientName;
      this.debtorInfo.phone = this.patient.phoneNo;
      if (this.isZeroInventory) {
        if (!this.sellDrugWithoutInventory) {
          this.$message({
            type: 'error',
            message: '部分药品库存不足！',
          });
        } else {
          this.$confirm('部分药品库存不足, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          }).then(() => {
            this.request(req);
          }).catch(() => {
          });
        }
      } else {
        this.request(req);
      }
    },
    request(reqData) {
      this.$api.feeDispense.editPending(reqData).then((res) => {
        this.serverTotal = res.actualReceivableAmt;
        this.newRecordVersion = res.recordVersion;
        this.dialogVisible = true;
      }).catch(() => {
        // console.log(error);
      });
    },
    getCoupon() {
      this.$api.member.coupon({ id: this.couponId }).then((res) => {
        this.couponType = res.paramType;
        this.couponVal = JSON.parse(res.paramValue);
      });
    },
    // 打印处方
    printScript() {
      // 打印拦截如果没有安装打印机插件
      const LODOP = getLodop();
      if (!LODOP && this.isPrint) {
        this.printShow = true;
        return;
      }
      this.$notify({
        title: '提示',
        message: '正在打印请稍后...',
        type: 'success',
      });
      if (this.record.medicineDrugPrescriptionList.length > 0) this.$refs.medicinePrint.print();
      if (this.record.patientChineseDrugList.length > 0) this.$refs.piecesPrint.print();
      if (this.record.patientInfusionList.length > 0) this.$refs.infusionPrint.print();
      if (this.record.patientStickingDrugGroupList.length > 0) this.$refs.applyPrint.print();
      if (this.record.examList.length > 0 || this.record.additionalList.length > 0) this.$refs.otherPrint.print();
    },
    // 打印预览
    printReview(name) {
      this.$notify({
        title: '提示',
        message: '正在打印请稍后...',
        type: 'success',
      });
      if (name === 'medicineDrugPrescriptionList') this.$refs.medicinePrint.print({ isReview: true });
      if (name === 'patientChineseDrugList') this.$refs.piecesPrint.print({ isReview: true });
      if (name === 'patientInfusionList') this.$refs.infusionPrint.print({ isReview: true });
      if (name === 'patientStickingDrugGroupList') this.$refs.applyPrint.print({ isReview: true });
      if (name === 'examList' || name === 'additionalList') this.$refs.otherPrint.print({ isReview: true });
    },
    // 打印输液卡
    printInfusionScript() {
      const LODOP = getLodop();
      if (!LODOP && this.isPrint) {
        this.printShow = true;
        return;
      }
      this.$api.outPatient.getRecord({ recordId: this.inquiryInfo.recordId }).then((res) => {
        this.record = res;
        this.$notify({
          title: '提示',
          message: '正在打开预览...',
          type: 'success',
        });
        this.$refs.infusionCardPrint.print();
      });
    },
    // 支付完成
    payComplated(data) {
      if (!this.isPrint) {
        this.reviewClose();
        return;
      }
      const changeData = (item) => {
        item.receivableAmt = item.amt;
        item.items = item.orderItemDetailedList.map((it) => ({
          drugName: it.designation,
          dose: it.dosage,
          dosage: it.totalDosage,
          saleUnit: it.unit,
          salePrice: it.price,
        }));
        return item;
      };
      const getID = item => ({ id: item.id });
      const wList = this.wPrescription.filter(isChecked).map(getID);
      const eList = this.ePrescription.filter(isChecked).map(getID);
      const inList = this.infusionPrescription.filter(isChecked).map(getID);
      const appList = this.applyPrescription.filter(isChecked).map(getID);
      const examList = this.orderExamList.filter(isChecked).map(getID);
      const addList = this.orderAdditionList.filter(isChecked).map(getID);
      const request = {
        orderId: data.orderId,
        orderItems: [
          ...wList,
          ...eList,
          ...appList,
          ...examList,
          ...addList,
          ...inList,
        ],
      };
      this.$api.feeDispense.smallTicketPrint(request).then((res) => {
        this.scriptList = {
          saleDrugPrescriptionList: res.orderDetailedLists.filter(item => item.type === 5).map(changeData),
          medicineDrugPrescriptionList:  res.orderDetailedLists.filter(item => item.type === 1).map(changeData),
          patientChineseDrugList: res.orderDetailedLists.filter(item => item.type === 2).map(changeData),
          patientInfusionList: res.orderDetailedLists.filter(item => item.type === 6).map(changeData),
          patientStickingDrugGroupList:  res.orderDetailedLists.filter(item => item.type === 7).map(changeData),
          orderExam: res.orderDetailedLists.filter(item => item.type === 3).map(changeData),
          orderAddition: res.orderDetailedLists.filter(item => item.type === 4).map(changeData),
          totalDiscountAmt: res.discountAmt,
          receivableAmt: res.totalAmt,
          actualReceivableAmt: BN(res.totalAmt).minus(res.discountAmt).toFixed(2),
        };
        this.scriptList.patientName = this.patient.patientName;
        this.$notify({
          title: '提示',
          message: '正在打开预览...',
          type: 'success',
        });
        this.$refs.receiptPrint.print();
        // 如果用户没有点击关闭我们自动给她退回列表页面
        setTimeout(() => {
          this.reviewClose();
        }, 3000);
      });
    },
    reviewClose() {
      this.$router.push({ name: 'waitFee' });
    },
    // 验证输入数字
    inputNumber(attrName, index) {
      this[attrName][index].discountAmt = this[attrName][index].discountAmt.replace(/[^\.\d]/g, '');
    },
    // 验证输入数字
    iptNumber() {
      this.wipeZero = this.wipeZero.replace(/[^\.\d]/g, '');
    },
    // 支付弹框关闭回调事件
    dialogClose() {
      console.log(111);
      this.getDetail();
    },
    // 获取诊所基础功能配置
    getHospitalConfig() {
      this.$api.clinicManagement.getHospitalConfig({
        configType: 10,
      }).then((res) => {
        this.sellDrugWithoutInventory = res.sellDrugWithoutInventory;
      });
    },
  },
  filters: {
    minusOffer(offer, total) {
      return BN(total).minus(offer).toFixed(3);
    },
  },
  mounted() {
    this.getDetail();
    this.getHospitalConfig();
  },
  computed: {
    // 判断是否有无库存的情况
    isZeroInventory() {
      const isInventory = (item) => {
        return item.items.some(it => (it.dosage * it.gramCount * it.ratio > it.inventoryCount));
      };
      const wpre = this.wPrescription.filter(isChecked).some(isInventory);
      const epre = this.ePrescription.filter(isChecked).some(isInventory);
      const ipre = this.infusionPrescription.filter(isChecked).some(isInventory);
      const apre = this.applyPrescription.filter(isChecked).some(isInventory);
      return wpre || epre || ipre || apre;
    },
    // 总的应收金额
    allTotalPrice() {
      const addFn = (a, b) => a + Number(b.receivableAmt);
      const addPrice = this.orderAdditionList.filter(isChecked).reduce(addFn, 0);
      const examPrice = this.orderExamList.filter(isChecked).reduce(addFn, 0);
      const wPrice = this.wPrescription.filter(isChecked).reduce(addFn, 0);
      const ePrice = this.ePrescription.filter(isChecked).reduce(addFn, 0);
      const inPrice = this.infusionPrescription.filter(isChecked).reduce(addFn, 0);
      const applyPrice = this.applyPrescription.filter(isChecked).reduce(addFn, 0);
      return BN(addPrice)
        .plus(examPrice)
        .plus(wPrice)
        .plus(ePrice)
        .plus(inPrice)
        .plus(applyPrice)
        .toFixed(2);
    },
    offer() {
      const addFn = (a, b) => a + Number(b.discountAmt);
      const addPrice = this.orderAdditionList.filter(isChecked).reduce(addFn, 0);
      const examPrice = this.orderExamList.filter(isChecked).reduce(addFn, 0);
      const wPrice = this.wPrescription.filter(isChecked).reduce(addFn, 0);
      const ePrice = this.ePrescription.filter(isChecked).reduce(addFn, 0);
      const inPrice = this.infusionPrescription.filter(isChecked).reduce(addFn, 0);
      const applyPrice = this.applyPrescription.filter(isChecked).reduce(addFn, 0);
      return BN(addPrice)
        .plus(examPrice)
        .plus(wPrice)
        .plus(ePrice)
        .plus(inPrice)
        .plus(applyPrice)
        .toFixed(2);
    },
    // 应收金额
    receivable() {
      return BN(this.allTotalPrice).minus(this.allOffer).toFixed(2);
    },
    // 能优惠的金额
    couponAmt() {
      if (this.hasCoupon && this.couponType !== 0) {
        if (this.couponType === 1) {
          const discount = 1 - this.couponVal.discount;
          return BN(this.allTotalPrice).minus(this.offer).multipliedBy(discount).toFixed(3);
        }
        if (this.couponType === 2) {
          const price = BN(this.allTotalPrice).minus(this.offer);
          if (price >= Number(this.couponVal.paramValue1)) {
            return this.couponVal.paramValue2;
          }
          return '0.00';
        }
      } else {
        return '0.00';
      }
      return '0.00';
    },
    allOffer() {
      let wipeZero = Number(this.wipeZero);
      if (isNaN(wipeZero)) wipeZero = 0;
      return BN(this.offer).plus(this.couponAmt).plus(wipeZero).toFixed(3);
    },
    // 是否打印小票
    isPrint: {
      get() {
        return this.$store.state.global.printConfig.isReceipt;
      },
      set(val) {
        this.$store.commit('changeReceipt', val);
      },
    },
    // 判断是否选了某一个处方
    isDisabled() {
      const hasMedicine = this.wPrescription.some(item => item.checked);
      const hasPatientChinese = this.ePrescription.some(item => item.checked);
      const hasInfusionPrescription = this.infusionPrescription.some(item => item.checked);
      const hasPatientStickingDrugGroupList = this.applyPrescription.some(item => item.checked);
      const hasOrderExamList = this.orderExamList.some(item => item.checked);
      const hasOrderAdditionList = this.orderAdditionList.some(item => item.checked);
      return !hasMedicine && !hasPatientChinese && !hasInfusionPrescription && !hasPatientStickingDrugGroupList && !hasOrderExamList && !hasOrderAdditionList;
    },
  },
};
